import styled, { css } from 'styled-components';

import { Spacer } from '@ontruck/orc';

const boxStyles = ({ onlyBorderRight }) => css`
  position: relative;
  min-width: 136px;
  flex: 0 1 20%;
  max-width: 190px;

  ${onlyBorderRight
    ? `
    border-right: 1px solid var(--greyMouse);
  `
    : `
    border: 1px solid var(--greyMouse);
  `}
`;

const StyledQuantityBox = styled(Spacer).attrs(() => ({ p: 'S' }))`
  ${boxStyles}
`;

export default StyledQuantityBox;
